import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logoo.webp';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="footer-left">
                    <img src={logo} alt="LuckyGarden" className="footer-logo" />
                </div>
                <div className="footer-right">
                    <div className="footer-contact">
                        <a href="mailto:info@luckygarden.at" className="footer-link">info@lucky-garden.at</a>
                        <a href="tel:+43123456789" className="footer-link">+43 123 456 789</a>
                        <span className="footer-link">Straubinger Straße 22, 4600 Wels</span>
                        <Link to="/datenschutz" className="footer-link">Datenschutz</Link>
                    </div>
                </div>
            </div>
            <div className="footer-bottom">
                <p className="footer-copyright">&copy; 2026 LuckyGarden — Alle Rechte vorbehalten</p>
            </div>
        </footer>
    );
};

export default Footer;
